import {Axios} from '@asocial/fe-utils'
import {createSelector, createSlice, Dispatch, PayloadAction} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import {useQuery} from 'react-query'
import {useSelector} from 'react-redux'
import {CursorType, ErrorResponsesType, TotalCountType} from 'shared/types'
import {ChatRequest, GetChatRequestsResponse} from '../types'

export type ChatRequestsProps = {
  totalCount: TotalCountType
  cursor: CursorType
  list: ChatRequest[]
  newList: string[]
}

const initialState: ChatRequestsProps = {
  totalCount: null,
  cursor: '',
  list: [],
  newList: []
}

export const chatRequestsModel = createSlice({
  name: 'chatRequests',
  initialState,
  reducers: {
    addChatRequestsData: (state, {payload}: PayloadAction<GetChatRequestsResponse>) => {
      state.totalCount = payload.totalCount
      state.cursor = payload.cursor
      state.list.push(...payload.data)
    },
    deleteChatRequest: (state, {payload: idUser}: PayloadAction<string>) => {
      state.list = state.list.filter((item) => item.userFrom.id !== idUser)
      state.totalCount && (state.totalCount -= 1)
    },
    addChatRequestsUp: (state, {payload}: PayloadAction<ChatRequest>) => {
      if (state.cursor === '') return
      if (state.list.find((item) => item.userFrom.id === payload.userFrom.id)) return

      state.list.unshift(payload)
      state.totalCount !== null && (state.totalCount += 1)
      state.newList.push(payload.userFrom.id)
    },
    clearNewChatRequest: (state) => {
      state.newList = []
    },
    clearChatRequests: () => initialState
  }
})

export const {
  addChatRequestsData,
  addChatRequestsUp,
  deleteChatRequest,
  clearNewChatRequest,
  clearChatRequests
} = chatRequestsModel.actions

export const GetChatRequests = (dispatch: Dispatch) =>
  useQuery<AxiosResponse<GetChatRequestsResponse>, ErrorResponsesType, AxiosResponse<GetChatRequestsResponse>, [string, ChatRequestsProps]>(
    ['getChatRequests', useSelector((state: RootState) => state.chatRequests)],
    ({queryKey: [_, {cursor}]}) => Axios.get(
      'activity/chat-requests',
      {params: {cursor: cursor || null}}
    ),
    {
      onSuccess: ({data}) => dispatch(addChatRequestsData(data)),
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  )

export const useChatRequestsList = () => useSelector(
  createSelector(
    (state: RootState) => state.chatRequests.list,
    (list) => list
  )
)

export const useChatRequestsNew = () => useSelector(
  createSelector(
    (state: RootState) => state.chatRequests.newList,
    (newList) => newList
  )
)

export const useChatRequestsCursor = () => useSelector(
  createSelector(
    (state: RootState) => state.chatRequests.cursor,
    (cursor) => cursor
  )
)

export const useChatRequestsTotalCount = () => useSelector(
  createSelector(
    (state: RootState) => state.chatRequests.totalCount,
    (totalCount) => totalCount
  )
)